import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    linkedinUrl: '',
    certificateUrl: '',
    skillName: '',
    fromWhatsApp: false
}

const whatsAppShareLinkedInSlice = createSlice({
    name: 'whatsAppShareLinkedIn',
    initialState,
    reducers: {
        setWhatsAppShareData: (state, action) => {
            const { linkedinUrl, certificateUrl, skillName, fromWhatsApp } = action.payload
            state.linkedinUrl = linkedinUrl
            state.certificateUrl = certificateUrl
            state.skillName = skillName
            state.fromWhatsApp = fromWhatsApp
        }
    }
})

export const { setWhatsAppShareData } = whatsAppShareLinkedInSlice.actions
export const selectWhatsAppSharelinkedIn = (state) => state.whatsAppShareLinkedIn
export default whatsAppShareLinkedInSlice.reducer